import { gql } from '@apollo/client'

import { INGREDIENT_KEYWORD_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const UPDATE_INGREDIENT_KEYWORD_DETAILS_MUTATION = gql`
  mutation updateIngredientKeywordDetails(
    $id: ID!
    $data: IngredientKeywordDetailsInput!
  ) {
    updateIngredientKeywordDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      uncategorized {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      synonyms {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      varieties {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      discarded {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }
    }
  }
  ${INGREDIENT_KEYWORD_NODE_FRAGMENT}
`

export default UPDATE_INGREDIENT_KEYWORD_DETAILS_MUTATION
